<template>
  <div class="view pa24">
    <el-form :model="serchParams" class="demo-form-inline" :inline="true">
      <el-row style="padding-top: 20px;">
        <el-form-item label="名称" label-width="70px" label-position="left" class="fromItem" >
          <el-input v-model="serchParams.name" placeholder="备案信息名称" clearable></el-input>
        </el-form-item>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="resetSearch">重置</el-button>
      </el-row>
    </el-form>
    <div class="d-flex">
      <el-button class="ma" type="primary" @click="handleAdd('add')">+添加备案信息</el-button>
    </div>
    <commonTable
        :tableData="tableData"
        :total="total"
        :currentPage="pageNum"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
    >
      <template v-slot:table>
        <el-table-column
            prop="name"
            align="center"
            label="备案信息名称"
            width="180"
        >
          <template slot-scope="scope">
            {{ scope.row.name}}
          </template>
        </el-table-column>
        <el-table-column
            prop="lotNumber"
            align="center"
            label="化妆品类型"
            width="180"
        >
          <template slot-scope="scope">
            {{ scope.row.type == 0 ? "普通化妆品" : scope.row.type == 1 ? "特殊化妆品" : "其他" }}
          </template>
        </el-table-column>
        <el-table-column
            prop="srcTradeNo"
            align="center"
            label="注册证书编号"
        >
          <template slot-scope="scope">
            {{ scope.row.certificateNo || '--' }}
          </template>
        </el-table-column>
        <el-table-column
            prop="isChina"
            align="center"
            label="注册人/备案人国籍"
            width="100"
        >
          <template slot-scope="scope">
            {{ scope.row.isChina==1 ? "中国" : "外国" }}
          </template>
        </el-table-column>
        <el-table-column
            prop="filingPerson"
            align="center"
            label="注册人/备案人中文名称"
        >
          <template slot-scope="scope">
            {{ scope.row.filingPerson || '--' }}
          </template>
        </el-table-column>
        <el-table-column
            prop="filingPersonAddress"
            align="center"
            label="注册人/备案人住所"
        >
          <template slot-scope="scope">
            {{ scope.row.filingPersonAddress || '--' }}
          </template>
        </el-table-column>
        <el-table-column
            prop="chinaLeader"
            align="center"
            label="境内责任人名称"
            width="200"
        >
          <template slot-scope="scope">
            {{ scope.row.chinaLeader || '--' }}
          </template>
        </el-table-column>
        <el-table-column
            prop="chinaLeaderAddress"
            align="center"
            label="境内责任人住所地址"
            width="200"
        >
          <template slot-scope="scope">
            {{ scope.row.chinaLeaderAddress || '--' }}
          </template>
        </el-table-column>
        <el-table-column
            prop="filingPersonAddress"
            align="center"
            label="生产企业信息"
            width="200"
        >
          <template slot-scope="scope">
            <el-popover
                placement="top"
                width="800"
                trigger="click">
              <el-table :data="scope.row.productionList">
                <el-table-column align="center" width="200" property="productionCompany" label="生产企业名称"></el-table-column>
                <el-table-column align="center" width="200" property="productionCompanyAddress" label="生产企业住所地址"></el-table-column>
                <el-table-column align="center" width="200" property="productionAddress" label="生产地址"></el-table-column>
                <el-table-column align="center" width="200" property="productionLicense" label="生产许可证编号"></el-table-column>
              </el-table>
              <el-button slot="reference" type="text">点击查看</el-button>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column align="center" width="200" label="操作">
          <template slot-scope="scope">
            <el-button type="text"  @click="handleAdd('edit', scope.row)">编辑</el-button>
            <el-button type="text"  @click="delOrder(scope.row)" class="redBtn">删除
            </el-button>
            <el-button type="text" @click="handleAdd('detail',scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </template>
    </commonTable>
    <el-dialog :title="title" :visible.sync="addFormVisible" append-to-body :close-on-click-modal="false">
      <el-form :model="addForm" :rules="rules" label-width="148px" ref="addForm">
        <div class="production-section">
          <div class="section-title">基本信息</div>
          <el-form-item label="备案信息名称" prop="name" >
            <el-input v-model="addForm.name" placeholder="请输入备案信息名称" :readonly="isDetail"></el-input>
          </el-form-item>
          <el-form-item label="化妆品类型" prop="type">
            <el-radio v-model="addForm.type" :label="0" :disabled="isDetail">普通化妆品</el-radio>
            <el-radio v-model="addForm.type" :label="1" :disabled="isDetail">特殊化妆品</el-radio>
          </el-form-item>
          <el-form-item label="注册证书编号" prop="certificateNo" v-if="addForm.type === 1">
            <el-input v-model="addForm.certificateNo" placeholder="请输入特殊化妆品注册证书编号" :readonly="isDetail"></el-input>
          </el-form-item>
          <el-form-item label="注册人/备案人国籍" prop="isChina">
            <el-radio v-model="addForm.isChina" :label="1" :disabled="isDetail">中国</el-radio>
            <el-radio v-model="addForm.isChina" :label="0" :disabled="isDetail">外国</el-radio>
          </el-form-item>
          <el-form-item label="注册人中文名称" prop="filingPerson" v-if="addForm.type === 1">
            <el-input v-model="addForm.filingPerson" placeholder="请输入注册人中文名称" :readonly="isDetail"></el-input>
          </el-form-item>
          <el-form-item label="注册人住所" prop="filingPersonAddress" v-if="addForm.type === 1">
            <el-input v-model="addForm.filingPersonAddress" placeholder="请输入注册人住所" :readonly="isDetail"></el-input>
          </el-form-item>
          <el-form-item label="备案人中文名称" prop="filingPerson" v-if="addForm.type === 0">
            <el-input v-model="addForm.filingPerson" placeholder="请输入备案人中文名称" :readonly="isDetail"></el-input>
          </el-form-item>
          <el-form-item label="备案人住所" prop="filingPersonAddress" v-if="addForm.type === 0">
            <el-input v-model="addForm.filingPersonAddress" placeholder="请输入备案人住所" :readonly="isDetail"></el-input>
          </el-form-item>
          <el-form-item label="境内责任人名称" prop="chinaLeader" v-if="addForm.isChina==0">
            <el-input v-model="addForm.chinaLeader" placeholder="请输入境内责任人名称" :readonly="isDetail"></el-input>
          </el-form-item>
          <el-form-item label="境内责任人住所地址" prop="chinaLeaderAddress" v-if="addForm.isChina==0">
            <el-input v-model="addForm.chinaLeaderAddress" placeholder="请输入境内责任人住所地址" :readonly="isDetail"></el-input>
          </el-form-item>
        </div>

        <!-- 生产企业信息（支持多组） -->
        <div class="production-section">
          <div class="section-title">生产企业信息（若有多个生产企业，依次填写）</div>
          <div v-for="(production, index) in addForm.productionList" :key="index" class="production-item">
            <el-card class="production-card">
              <div slot="header" class="clearfix">
                <span>生产企业 {{ index + 1 }}</span>
                <el-button
                    v-if="addForm.productionList.length > 1 && !isDetail"
                    style="float: right; padding: 3px 0"
                    type="text"
                    @click="removeProduction(index)"
                    class="redBtn"
                >
                  删除
                </el-button>
              </div>

              <el-form-item
                  :label="'生产企业名称' + (index > 0 ? ' ' + (index + 1) : '')"
                  :prop="'productionList.' + index + '.productionCompany'"
                  :rules="[{ required: true, message: '请输入生产企业名称', trigger: 'blur' }]"
              >
                <el-input
                    v-model="production.productionCompany"
                    placeholder="请输入生产企业名称" :readonly="isDetail"
                ></el-input>
              </el-form-item>

              <el-form-item
                  :label="'生产企业住所地址' + (index > 0 ? ' ' + (index + 1) : '')"
                  :prop="'productionList.' + index + '.productionCompanyAddress'"
                  :rules="[{ required: true, message: '请输入生产企业住所地址', trigger: 'blur' }]"
              >
                <el-input
                    v-model="production.productionCompanyAddress"
                    placeholder="请输入生产企业住所地址" :readonly="isDetail"
                ></el-input>
              </el-form-item>

              <el-form-item
                  :label="'生产地址' + (index > 0 ? ' ' + (index + 1) : '')"
                  :prop="'productionList.' + index + '.productionAddress'"
                  :rules="[{ required: true, message: '请输入生产地址', trigger: 'blur' }]"
              >
                <el-input
                    v-model="production.productionAddress"
                    placeholder="请输入生产地址" :readonly="isDetail"
                ></el-input>
              </el-form-item>

              <el-form-item
                  :label="'生产许可证编号' + (index > 0 ? ' ' + (index + 1) : '')"
                  :prop="'productionList.' + index + '.productionLicense'"
              >
                <el-input
                    v-model="production.productionLicense"
                    placeholder="请输入生产许可证编号" :readonly="isDetail"
                ></el-input>
                <p style="font-size: 12px;color: red;">注：产品来源为国产化妆品，生产许可证编号为必填</p>
              </el-form-item>
            </el-card>
          </div>

          <el-button
              type="primary"
              plain
              @click="addProduction"
              style="margin-top: 15px;"
              v-if="!isDetail"
          >
            + 添加生产企业
          </el-button>
        </div>

      </el-form>
      <div slot="footer" class="dialog-footer" v-if="!isDetail">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitChange">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import commonTable from "@/components/common/commonTable";
import {checkPermission} from "@/directives/permission";
import {selectFilingList,addOrUpdateFiling,fetchDelFiling} from '@/api/hzpFilingInfo.js'
export default {
  name: "dealerList",
  components: {
    commonTable,
  },
  data() {
    return {
      addFormVisible: false,
      changeDealerList: [],
      rules: {
        name:[
            {required: true, message: '请输入产品名称', trigger: 'blur'},
        ],
        type: [
          {required: true, message: '请选择化妆品类型', trigger: 'blur'},
        ],
        certificateNo: [
          {required: true, message: '请输入许可证编号', trigger: 'blur'},
        ],
        filingPerson: [
          {required: true, message: '请输入备案人中文名称', trigger: 'blur'},
        ],
        filingPersonAddress: [
          {required: true, message: '请输入备案人住所标签', trigger: 'blur'},
        ],
        chinaLeader: [
          {required: true, message: '请输入境内责任人名称', trigger: 'blur'},
        ],
        chinaLeaderAddress: [
          {required: true, message: '请输入境内责任人住所地址', trigger: 'blur'},
        ],
        isChina:[
            {required: true, message: '请选择备案人/注册人国籍', trigger: 'blur'},
        ]
      },
      addForm: {
        id: '',
        name:'',
        type: 0,
        certificateNo: '',
        certificatePerson: '',
        certificatePersonAddress: '',
        isChina: 1,
        filingPerson: '',
        filingPersonAddress: '',
        chinaLeader: '',
        chinaLeaderAddress: '',
        productionList: [
          {
            productionCompany: '',
            productionCompanyAddress: '',
            productionAddress: '',
            productionLicense: ''
          }
        ],
        productionCompany: '',

      },
      tableData: [],
      pageSize: 10,
      pageNum: 1,
      total: 0,
      serchParams: {
        name:''
      },
      title:'新增备案信息',
      isDetail:false
    };
  },
  created() {
    let userInfo = JSON.parse(localStorage.getItem('info'));

  },
  mounted() {
    this.getList();
  },
  methods: {
    checkPermission,
    // 添加生产企业
    addProduction() {
      this.addForm.productionList.push({
        productionCompany: '',
        productionCompanyAddress: '',
        productionAddress: '',
        productionLicense: ''
      });
    },
// 删除生产企业
    removeProduction(index) {
      if (this.addForm.productionList.length > 1) {
        this.addForm.productionList.splice(index, 1);
      }
    },
    submitChange() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          // 处理提交逻辑
          this.addForm.productionCompany = JSON.stringify(this.addForm.productionList)
          addOrUpdateFiling(this.addForm).then(res => {
            if (res.code === 200) {
              this.$message.success("操作成功")
              this.getList();
              this.addFormVisible = false;
            }
          })
        }
      });
    },
    showProductionCompany(row){

    },
    detail(row) {

    },
    classIdChange() {

    },
    copy(context) {
      // 创建输入框元素
      let oInput = document.createElement('input');
      // 将想要复制的值
      oInput.value = context;
      // 页面底部追加输入框
      document.body.appendChild(oInput);
      // 选中输入框
      oInput.select();
      // 执行浏览器复制命令
      document.execCommand('Copy');
      // 弹出复制成功信息
      this.$message.success('复制成功');
      // 复制后移除输入框
      oInput.remove();
    },
    handleSizeChange(num) {
      this.pageSize = num;
      this.pageNum = 1;
      this.getList();
    },
    handleCurrentChange(num) {
      this.pageNum = num;
      this.getList();
    },
    handleAdd(type, data) {
      this.isDetail = false
      this.addFormVisible = true;
      if ('edit'== type){
        this.title = '编辑备案信息'
        this.addForm = JSON.parse(JSON.stringify(data))
      }else if('detail'==type){
        this.title = '查看备案信息'
        this.addForm = JSON.parse(JSON.stringify(data))
        this.isDetail = true
      }else if ('add'==type){
        this.$nextTick(() => {
          this.restForm()
        })
      }
    },
    search() {
      this.pageNum = 1
      this.getList()
    },
    resetSearch() {
      this.serchParams.name = ''
      this.pageNum = 1
      this.getList()
    },
    restForm(){
      if (this.$refs.addForm) {
        this.$refs.addForm.clearValidate();
      }
      this.addForm = {
        id: '',
        filingId:'',
        type: 0,
        certificateNo: '',
        certificatePerson: '',
        certificatePersonAddress: '',
        isChina: 1,
        filingPerson: '',
        filingPersonAddress: '',
        chinaLeader: '',
        chinaLeaderAddress: '',
        productionList: [
          {
            productionCompany: '',
            productionCompanyAddress: '',
            productionAddress: '',
            productionLicense: ''
          }
        ],
      }
    },
    getList() {
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      }
      params = Object.assign(params, this.serchParams)
      selectFilingList(params).then(res => {
        this.tableData = res.data.list
        this.tableData.forEach(item => {
          if (item.productionCompany){
            item.productionList = JSON.parse(item.productionCompany)
          }
        })
        this.total = res.data.total
      })
    },
    delOrder(row) {
      this.$confirm('此操作将永久删除该备案信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        fetchDelFiling(row.id).then(res=>{
          console.log('res',res)
          if (res.code === 200) {
            this.$message.success("删除成功")
            this.getList();
          }else {
            this.$message.error(res.message)
          }
        })
      }).catch(() => {
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.name_status {
  display: inline-block;
  width: 26px;
  height: 17px;
  line-height: 15px;
  background: rgba(63, 114, 246, 0.11);
  border: 1px solid #3F72F6;
  border-radius: 4px;
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #3F72F6;
  text-align: center;
}

.name_status1 {
  display: inline-block;
  width: 26px;
  height: 17px;
  line-height: 15px;
  background: rgba(243, 136, 46, 0.11);
  border: 1px solid #F3882E;
  border-radius: 4px;
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #F3882E;
  text-align: center;
}

.copyTxt {
  display: inline-block;
  margin-left: 5px;
  cursor: pointer;
  color: #3F72F6;
}

.greenTag {
  color: #fff;
  background: #08A89B;
  border-radius: 6px;
  padding: 3px 5px;
  overflow: hidden;

}

.greyTag {
  background: #e5e5e5;
  color: #333;
  border-radius: 6px;
  padding: 3px 5px;
  overflow: hidden;

}

.redTag {
  background: #e5e5e5;
  color: #f00;
  border-radius: 6px;
  padding: 3px 5px;
  overflow: hidden;
}

.redBtn, .redColor {
  color: #f00;
}

// 生产企业样式
.production-section {
  margin-top: 20px;
  padding: 15px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background-color: #fafafa;
}

.section-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #333;
}

.production-item {
  margin-bottom: 15px;
}

.production-card {
  border: 1px solid #ebeef5;
}

.production-card:last-child {
  margin-bottom: 0;
}

</style>

